import {dateReader, kilosToTons, numberDisplay} from 'helpers/UnitsFormatHandler';

import {Stack} from '@mui/material';
import {useGetHogLweFormatter} from 'hooks/useGetHogLweFormatter';
import {FormSelectionEnum, type ActionProcessed, type HarvestRecommendationProcessed} from 'interfaces';
import {useTranslation} from 'react-i18next';
import {useGetForecastState} from '../../hooks/swr';
import {type SWRresourceId} from '../../hooks/swr/swrHookFactory';
import HarvestCardValue from './HarvestCardValue';

const ActionCardContent = ({
  action,
  isRecommendation,
  isVisible,
}: {
  action: ActionProcessed | HarvestRecommendationProcessed;
  isRecommendation: boolean;
  isVisible: boolean;
}) => {
  const {formatLweHog} = useGetHogLweFormatter();
  const date = action.date && dateReader(action.date);
  const forecastResourceId: SWRresourceId | undefined =
    isVisible && !isRecommendation && date && action.cageId ? [date, action.cageId] : undefined;
  const {data: forecast} = useGetForecastState({resourceId: forecastResourceId});

  const {t} = useTranslation('common');
  const biomass = numberDisplay(kilosToTons(formatLweHog(action.biomass ?? 0, action.species ?? undefined)), 0);
  const remainingBiomass =
    action.cellActionType === FormSelectionEnum.harvest && forecast
      ? `(${numberDisplay(
          kilosToTons(formatLweHog(forecast?.closingBiomass ?? 0, action.species ?? undefined)),
          0,
        )} ${t('left')})`
      : '';
  const weight = action.weight && numberDisplay(formatLweHog(action.weight, action.species ?? undefined), 2);
  const count = action.count && numberDisplay(action.count, 0);
  const isActionWithBiomass = action.biomass !== null && action.weight !== null && action.count !== null;

  return (
    <>
      {isActionWithBiomass && (
        <Stack spacing="2px" style={{marginTop: '6px'}}>
          <HarvestCardValue
            value={biomass}
            unit={t('tonsAbbreviated')}
            extra={remainingBiomass}
            fullHarvest={action?.fullHarvest}
            dataTestId="action-card-biomass"
          />
          <HarvestCardValue value={weight} unit={t('kiloAbbreviated')} dataTestId="action-card-weight" />
          <HarvestCardValue value={count} unit={t('countAbbreviated')} dataTestId="action-card-count" />
        </Stack>
      )}
    </>
  );
};

export default ActionCardContent;
